import { ManagedStructure, Payment } from "../types/Payment";
import client from "./axios";

const baseUrl = "https://internal-api.getmoveapp.com/api/v1/admin/management";
//const baseUrl = "http://localhost:3000/api/v1/admin/management";

export type PlatformLock = {
  locked: boolean;
  lockedAt: string | null;
  message: string | null;
};

export const Management = {
  // Blocco globale dei circoli: gestionale inaccessibile agli Host e circoli
  // nascosti nell'app finché il Superadmin non sblocca.
  getPlatformLock: () => client.get<PlatformLock>(`${baseUrl}/platform-lock`),
  setPlatformLock: (locked: boolean, message?: string) =>
    client.put<PlatformLock>(`${baseUrl}/platform-lock`, { locked, message }),
  // Elenco di tutte le strutture con dati di fatturazione, stato e pagamenti.
  getStructures: () =>
    client.get<{ list: ManagedStructure[] }>(`${baseUrl}/structures`),
  setStructureActive: (structureId: string, active: boolean) =>
    client.put<{ structure: ManagedStructure }>(
      `${baseUrl}/structures/${structureId}/active`,
      { active }
    ),
  // Blocca/sblocca il singolo circolo (gestionale + visibilità in app).
  setStructureLock: (structureId: string, locked: boolean, message?: string) =>
    client.put<{ locked: boolean; lockMessage: string | null }>(
      `${baseUrl}/structures/${structureId}/lock`,
      { locked, message }
    ),
  // Imposta il costo abbonamento annuale del circolo (ricalcola gli stati pagamenti).
  setStructureAnnualFee: (structureId: string, annualFee: number | null) =>
    client.put<{ annualFee: number | null; total: number; covered: boolean }>(
      `${baseUrl}/structures/${structureId}/annual-fee`,
      { annualFee }
    ),
  uploadContract: (structureId: string, fd: FormData) =>
    client.post<{ structure: ManagedStructure }>(
      `${baseUrl}/structures/${structureId}/contract`,
      fd
    ),
  getContractUrl: (structureId: string) =>
    client.get<{ url: string }>(
      `${baseUrl}/structures/${structureId}/contract-url`
    ),
  getPayments: (structureId: string) =>
    client.get<{ list: Payment[] }>(`${baseUrl}/payments/${structureId}`),
  // Segna un pagamento. La fattura (opzionale) viaggia nel campo "document".
  createPayment: (fd: FormData) =>
    client.post<{ payment: Payment }>(`${baseUrl}/payments`, fd),
  getInvoiceUrl: (paymentId: string) =>
    client.get<{ url: string }>(`${baseUrl}/payments/${paymentId}/invoice-url`),
  deletePayment: (paymentId: string) =>
    client.delete<{ message: string }>(`${baseUrl}/payments/${paymentId}`),
};
